import React, { FunctionComponent } from 'react'
import iconTransferencia from '../../../assets/icons/pagamentos/icon-transferencia.svg'
import { Icon } from '../styles'
import { IconsProp } from '../Icons.type'

const IconTransferenciBancaria: FunctionComponent<IconsProp> = ({ size }) => (
  <Icon src={iconTransferencia} />
)
export default IconTransferenciBancaria
